// wp-interactions.js — WorkPower Comic-CI 2026
// 1. Cart Drawer Add — intercepts .wp-product-form, opens Cart Drawer
// 2. Hero Tilt       — subtle 3-D tilt on .wp-hero-visual via mousemove

(function () {
  'use strict';

  // ─── Cart Drawer Add ───────────────────────────────────────────────

  function initCartDrawerAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.wp-product-form');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]:not([disabled])');
      if (!btn) return;

      var vidInput = form.querySelector('input[name="id"]');
      if (!vidInput) return;

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';

      var stickyBtn = document.querySelector('.wp-pdp-sticky-btn');
      if (stickyBtn) stickyBtn.disabled = true;

      var fd = new FormData(form);

      // Attach section IDs so the response includes section HTML for morphSection
      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        sectionIds.push(el.dataset.sectionId);
      });
      if (sectionIds.length) {
        fd.append('sections', sectionIds.join(','));
        fd.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (addResponse) {
          // Fetch current cart to get accurate item_count
          return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              return { addResponse: addResponse, cart: cart };
            });
        })
        .then(function (result) {
          var cart = result.cart;
          var addResponse = result.addResponse;
          var count = cart.item_count || 0;

          // 1. Sync em.wp-cart-counter (visible WorkPower header badge)
          syncWpCartBadge(count);

          // 2. Dispatch CartUpdateEvent so cart-icon.js + cart-items-component update
          var sections = addResponse.sections || null;
          var sectionId = null;
          if (sections) {
            sectionId = Object.keys(sections)[0] || null;
          }

          // Dispatch Horizon 'cart:update' event so cart-items-component re-renders
          // and cart-icon.js updates its bubble via onCartUpdate.
          // detail.data.sections must contain the section HTML from the add response
          // so cart-items-component can morphSection instead of doing a full re-fetch.
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                source: 'wp-interactions',
                itemCount: count,
                sections: sections,
                originSectionId: null
              }
            }
          }));

          // Also dispatch workpower:cart-count:update for cart-icon.js safety net
          document.dispatchEvent(new CustomEvent('workpower:cart-count:update', {
            detail: { itemCount: count }
          }));

          // 3. Open Cart Drawer
          openCartDrawer();

          // 4. Button feedback
          btn.textContent = '✓ Hinzugefügt';
          if (stickyBtn) stickyBtn.textContent = '✓ Hinzugefügt';
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = originalText;
            if (stickyBtn) {
              stickyBtn.disabled = false;
              stickyBtn.textContent = originalText;
            }
          }, 2200);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
          if (stickyBtn) {
            stickyBtn.disabled = false;
            stickyBtn.textContent = originalText;
          }
        });
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    // Fallback: simulate click on the drawer trigger button
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) trigger.click();
  }

  function syncWpCartBadge(count) {
    var wpCartBtn = document.getElementById('wp-cart-btn');
    if (!wpCartBtn) return;
    var counter = wpCartBtn.querySelector('em.wp-cart-counter');
    if (count > 0) {
      if (!counter) {
        counter = document.createElement('em');
        counter.className = 'wp-cart-counter';
        counter.setAttribute('aria-hidden', 'true');
        wpCartBtn.appendChild(counter);
      }
      counter.textContent = String(count);
      wpCartBtn.setAttribute('aria-label', 'Warenkorb (' + count + ' Artikel)');
    } else {
      if (counter) counter.remove();
      wpCartBtn.setAttribute('aria-label', 'Warenkorb');
    }
  }

  // ─── Hero Tilt ──────────────────────────────────────────────────────

  function initHeroTilt() {
    var grid   = document.querySelector('.wp-hero-comic-grid');
    var visual = document.querySelector('.wp-hero-visual');
    if (!grid || !visual) return;
    if ('ontouchstart' in window) return; // skip touch devices

    var rect, cx, cy;

    function onEnter() {
      rect = grid.getBoundingClientRect();
      cx   = rect.left + rect.width  / 2;
      cy   = rect.top  + rect.height / 2;
    }

    function onMove(e) {
      if (!rect) return;
      var dx = (e.clientX - cx) / (rect.width  / 2);
      var dy = (e.clientY - cy) / (rect.height / 2);
      var rx = (-dy * 4).toFixed(2);
      var ry = ( dx * 4).toFixed(2);
      visual.style.transform =
        'perspective(900px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.02)';
    }

    function onLeave() {
      visual.style.transform = '';
    }

    grid.addEventListener('mouseenter', onEnter);
    grid.addEventListener('mousemove',  onMove);
    grid.addEventListener('mouseleave', onLeave);
  }

  // ─── Init ───────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCartDrawerAdd();
      initHeroTilt();
    });
  } else {
    initCartDrawerAdd();
    initHeroTilt();
  }
}());
